module.exports = "pegasus_template/assets/email1-img11.png";